export const getServerSideApiBasement = () =>
  process.env.NODE_ENV === 'production' && 'http://zelos-server.zelos:8000' ||
  process.env.NODE_ENV === 'development' && 'http://server:8000' ||
  '';
